import { push } from 'react-router-redux';
import { savePosition } from '../app/AppActions';

export const navigateToThreeD = (elementData) => {
    return (dispatch, getState) => {
        dispatch(savePosition(elementData));
        dispatch(push(`/${getState().app.tourId}/${getState().app.tourType.charAt(0)}/3d`));
    }
}